/*
 * Copyright (c) 2025 Ping Identity Corporation. All rights reserved.
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
export function isExpiryWithinThreshold(oauthThreshold, tokenExpiry) {
    if (oauthThreshold && tokenExpiry) {
        const expiryTimeMinusThreshold = tokenExpiry - oauthThreshold;
        const result = expiryTimeMinusThreshold < Date.now();
        return result;
    }
    return false;
}
//# sourceMappingURL=token.utils.js.map